import { trafficSourcesForSegments } from "app/Shared/utils";

import { trafficSources } from "../../constants";

export type TrafficSource = (typeof trafficSources)[number];

export const TRAFFIC_SOURCES = trafficSources.map((source) => ({
    title: trafficSourcesForSegments[source].title,
    value: source,
}));
